// import React, { useEffect, useState } from "react";
// import "./offer.scss";

// const offers = [
//     "50% Off on all products!",
//     "Buy 1 Get 1 Free!",
//     "Flash Sale: Ends Tonight!",
// ];

// const OfferSlider = () => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [transitionOff, setTransitionOff] = useState(false);
//     // const [transition, setTransition] = useState(`translateX(-${0 * 100}%)`);

//     useEffect(() => {
//         const interval = setInterval(() => {
//             console.log('check val - ', (currentIndex + 1) % offers.length);

//             setCurrentIndex((prevIndex) => {
//                 console.log('check val inside - ', prevIndex);
//                 if (prevIndex == 2) {
//                     // setTransitionOff((prevTransition) => {
//                     //     return !prevTransition
//                     // })
//                     setTransitionOff(true)
//                 }
//                 else {
//                     if (transitionOff) {
//                         // setTransitionOff((prevTransition) => {
//                         //     return !prevTransition
//                         // })
//                         setTransitionOff(false)
//                     }
//                 }
//                 return (prevIndex + 1) % offers.length
//             })
//         }, 1000); // Change slide every 4 seconds
//         return () => clearInterval(interval);
//     }, []);

//     useEffect(() => {
//         if (transitionOff) {

//         }
//     }, [transitionOff])

//     console.log('transitionOff - ', transitionOff);


//     return (
//         <div className="offer-slider-container">
//             <div className="slider-wrapper">
//                 <div
//                     className="slider"
//                     // style={{
//                     //     transform: transitionOff ? 'none' : `translateX(-${currentIndex * 100}%)`,
//                     // }}
//                     style={!transitionOff ? {
//                         transform: `translateX(-${currentIndex * 100}%)`,
//                     }
//                         : { transform: `none` }}
//                 >
//                     {offers.map((offer, index) => (
//                         <div className="slide" key={index}>
//                             {offer}
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default OfferSlider;





import React, { useEffect, useState } from "react";
import "./offer.scss";

const offers = [
    "50% Off on all products!",
    "Buy 1 Get 1 Free!",
    "Flash Sale: Ends Tonight!",
];

const OfferSlider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isResetting, setIsResetting] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                // If we reach the last slide, initiate a reset
                if (prevIndex === offers.length - 1) {
                    setIsResetting(true);
                    return 0; // Reset to the beginning position
                } else {
                    return prevIndex + 1; // Move to the next slide
                }
            });
        }, 3000); // Change slide every 3 seconds

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (isResetting) {
            // After resetting to the beginning, turn off the resetting state
            const timeout = setTimeout(() => {
                setIsResetting(false);
            }, 50); // Small delay to ensure reset occurs

            return () => clearTimeout(timeout);
        }
    }, [isResetting]);

    return (
        <div className="offer-slider-container">
            <div className="add-skew"></div>
            <div className="slider-wrapper">
                <div
                    className={`slider ${isResetting ? "no-transition" : ""}`}
                    style={{
                        transform: `translateX(-${currentIndex * 100}%)`,
                    }}
                >
                    {offers.map((offer, index) => (
                        <div className="slide" key={index}>
                            {offer}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OfferSlider;
